import React from 'react';
import cn from "classnames";
import { isEmpty } from "lodash";
import ReactTooltip from "react-tooltip";
import { TableHeader } from "./TableHeader";
import ItemRow from "./ItemRow";

const WriteOffReasonList = ({ reasons, onEdit, onDelete }) => {

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}
                    >
                        <table className="kt-datatable__table" style={{ minHeight: '700px' }}>
                            <TableHeader />
                            <tbody className="kt-datatable__body">
                            {
                                isEmpty(reasons) ? (
                                    <tr>
                                        <td colSpan={8}>
                                            <span className="kt-datatable--error"/>
                                        </td>
                                    </tr>
                                ) : (
                                    reasons.map((item) => (
                                        <ItemRow key={item.id} item={item} onEdit={onEdit} onDelete={onDelete} />
                                    ))

                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip effect="solid" type="dark" place="top" />
        </div>
    );
};

export default WriteOffReasonList;
